import Error from '../model/Error';
import Location from '../dto/resource/Location';
import axios from 'axios';

export default class LocationRepository {

    static findAll() {
        return new Promise((resolve, reject) => {
            axios
                .get('/club/resources/locations')
                .then(response => {
                    resolve(response.data.data.map(data => Location.fromData(data)));
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findAllByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offerings/locations`)
                .then(response => {
                    resolve(response.data.data.map(data => Location.fromData(data)));
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(locationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/resources/locations/${locationId}`)
                .then(response => resolve(Location.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(location) {
        const data = {
            name: location.name,
            shortName: location.shortName,
            areaName: location.areaName,
            fieldName: location.fieldName,
            note: location.note,
            type: location.type,
            street: location.street,
            addressCo: location.addressCo,
            postalCode: location.postalCode,
            city: location.city,
            size: location.size !== '' ? parseInt(location.size) : null,
            maxPersons: location.maxPersons !== '' ? parseInt(location.maxPersons) : null,
        };

        return new Promise((resolve, reject) => {
            axios
                .post('/club/resources/locations', data)
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(location) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${location.id}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(location) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/resources/locations/${location.id}/archived`, {
                    archived: true,
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(location) {
        const data = {
            name: location.name,
            shortName: location.shortName,
            note: location.note,
            type: location.type,
            street: location.street,
            addressCo: location.addressCo,
            postalCode: location.postalCode,
            city: location.city,
            size: location.size !== '' ? parseInt(location.size) : null,
            maxPersons: location.maxPersons !== '' ? parseInt(location.maxPersons) : null,
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${location.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(location, image, progressCallback) {
        const config = {
            onUploadProgress: function (progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: {'Content-Type': 'application/octet-stream'}
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${location.id}/image`, image, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(location) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${location.id}/image`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
